import {useQuery} from '@tanstack/react-query';
import {PaginatedBackendResponse} from '../../../http/backend-response/pagination-response';
import {DatabaseNotification} from '../../database-notification';
import {apiClient} from '../../../http/query-client';
import { BackendResponse } from '@common/http/backend-response/backend-response';

interface Response extends BackendResponse {
  pagination: {
    data: DatabaseNotification[];
    current_page: number;
    from: number;
    last_page: number;
    per_page: number;
    to: number;
    total: number;
  };
}

interface Params {
  perPage?: number;
}

/**
 * Fetch user notifications with REAL-TIME POLLING (30 seconds)
 * 
 * ✅ UPDATED: Now includes automatic polling for real-time updates
 */
export function useUserNotifications(params?: Params) {
  return useQuery<Response>({
    queryKey: ['notifications', params],
    queryFn: () => fetchNotifications(params),
    // ✅ NEW: Enable automatic refetching
    refetchInterval: 30000, // Refetch every 30 seconds (30000ms)
    refetchIntervalInBackground: true, // Continue polling even when window is not focused
    refetchOnWindowFocus: true, // Also refetch when user returns to the tab
    staleTime: 20000, // Consider data stale after 20 seconds
  });
}

function fetchNotifications(params?: Params) {
  return apiClient
    .get<Response>('notifications', {
      params: {
        perPage: params?.perPage || 10,
      },
    })
    .then(response => response.data);
}
